module.exports = __webpack_public_path__ + "assets/e7dc475836e372345ad4d1910067b7c1.mp3";